import logo from './logo.png'
import profilePhoto from './profile_image.png'


export const siteIcons = {
    logo: logo,
    profilePhoto: profilePhoto,
}